import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "apInput__inner" }
const _hoisted_2 = {
  key: 0,
  class: "apInput__label"
}
const _hoisted_3 = ["type", "value", "placeholder", "disabled", "maxlength", "max"]
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['apInput', { 'apInput--error': _ctx.hasErrorText }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['apInput__field', {'apInput__field--border': _ctx.border}])
      }, [
        _createElementVNode("input", {
          class: "apInput__input",
          type: _ctx.composeMask,
          value: _ctx.modelValue,
          placeholder: _ctx.placeholder,
          disabled: _ctx.disabled,
          maxlength: _ctx.length,
          max: _ctx.max,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
        }, null, 40, _hoisted_3),
        (_ctx.currency)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "₸"))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", { class: "apInput__hint" }, _toDisplayString(_ctx.hintOrError), 513), [
          [_vShow, _ctx.hintOrError]
        ])
      ]),
      _: 1
    })
  ], 2))
}